export const ENCRYPTION_OPTIONS = [
  { value: "none", label: "None" },
  { value: "starttls", label: "STARTTLS" },
  { value: "ssl", label: "TLS/SSL" },
];

export const AUTH_OPTIONS = [
  { value: "auto", label: "Auto" },
  { value: "plain", label: "PLAIN" },
  { value: "login", label: "LOGIN" },
  { value: "cram-md5", label: "CRAM-MD5" },
  { value: "ntlm", label: "NTLM" },
  { value: "xoauth2", label: "XOAUTH2" },
];

export const DEFAULT_PORTS = { none: 25, starttls: 587, ssl: 465 };

export const optionLabel = (options, value) =>
  options.find((o) => o.value === value)?.label ?? value;